import Immutable from 'seamless-immutable';
import { RESET_MEMBER_PRIVILEGE_UI, SET_AVAILABLE_PAYMENT_INSTRUMENTS, SET_MEMBER_PRIVILEGE, SET_SELECTED_HOURS, SET_SELECTED_HOURS_FOR_HOUSEHOLD_MEMBER } from '../actions/customer.household.actions';
export var INITIAL_STATE = Immutable({
  privileges: {},
  selectedHours: {},
  paymentInstruments: []
});
var generateDefaultSelectableHours = function generateDefaultSelectableHours() {
  return Array.from(new Array(24), function (i, hour) {
    return {
      hour: hour,
      days: Array.from(new Array(7), function (i, day) {
        return {
          day: day,
          id: "".concat(hour, "_").concat(day),
          selected: false
        };
      })
    };
  });
};
var getHourArrayForMember = function getHourArrayForMember(member) {
  var hourArray = generateDefaultSelectableHours();
  if (member.Privileges.DayAndTimePrivileges) {
    member.Privileges.DayAndTimePrivileges.forEach(function (priv) {
      for (var i = 0; i < priv.DurationMinutes / 60; i++) {
        hourArray[priv.StartingHour + i].days[priv.DayOfWeek].selected = true;
      }
    });
  }
  return hourArray;
};
export default function MemberPrivilegesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case SET_MEMBER_PRIVILEGE:
      return state.set('privileges', state.privileges.merge(payload, {
        deep: true
      }));
    case SET_AVAILABLE_PAYMENT_INSTRUMENTS:
      return state.set('paymentInstruments', payload);
    case SET_SELECTED_HOURS:
      return state.set('selectedHours', payload);
    case SET_SELECTED_HOURS_FOR_HOUSEHOLD_MEMBER:
      return state.set('selectedHours', getHourArrayForMember(payload));
    case RESET_MEMBER_PRIVILEGE_UI:
      return INITIAL_STATE;
    default:
      return state;
  }
}